<template>
  <div class="history-section">
    <div class="modal-body-title">{{ history.userName }}</div>
    <div class="modal-body-time">{{ history.timeModified | formatLastUpdate }}</div>
    <div class="clearfix"></div>
    <div class="modal-body-collapse-btn" @click="isExpanded = !isExpanded">
      <Icon name="chevron-right" class="event-icon" v-if="isExpanded"></Icon>
      <Icon name="chevron-down" class="event-icon" v-if="!isExpanded"></Icon>
      <span>{{ history.fieldsChangeCount }} changes</span>
    </div>
    <transition name="fade">
      <div v-if="isExpanded">
        <div class="modal-body-table">
          <b-table class="modal-table" striped outlined small bordered hover :items="history.items"></b-table>
        </div>
        <div class="modal-body-comments">{{ history.additionalComment }}</div>
      </div>
    </transition>
    <div class="border-bottom"></div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/chevron-right';
  import 'vue-awesome/icons/chevron-down';

  import Icon from 'vue-awesome/components/Icon';
  import Vue from 'vue';
  import moment from 'moment';

  Vue.filter('formatLastUpdate', function (value) {
    if (value) {
      let time = new Date(value);
      return moment(String(time)).format('h:mm A MM/DD/YYYY');
    }
  });

  export default {
    name: '',
    components: {
      Icon
    },
    data () {
      return {
        isExpanded: false
      }
    },
    props: {
      history: {
        type: Object,
        default: {}
      }
    },
    methods: {},
    computed: {}
  }
</script>

<style lang="less" scoped="">
  @import '../../styles/variables.less';

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .border-bottom {
    width: 80%;
    background-color: @grey-4;
    height: 1px;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// HistoryModalSection.vue?18bf1768